<template>
    <header class="o-d-header header">
        <AHeroTitle text="Desktop hospital map"/>
        <button
            type="button"
            class="header__button"
            :aria-label="ariaLabel"
            @click="handleClick"
        >
            <svg-icon
                original
                name="icons/logo_mobile"
                class="header__icon"
            />
        </button>
        <span class="o-d-header__text">
            {{$t('o-d-header__text')}}
        </span>
        <ADropdown
            v-model="locale"
            :items="dropdownOptions"
            name-field="label"
            key-field="value"
            @onChange="handleChangeLocale"
            @onOpenChange="handleOpenClose"
        />
    </header>
</template>

<script>
import  {
    mapState,
    mapActions,
    mapGetters 
} from 'vuex';

import ADropdown from '../../atoms/a-dropdown/a-dropdown';
import AHeroTitle from '../../atoms/a-hero-title/a-hero-title';
import { 
    SHOW_OVERLAY,
    CHECK_SEARCH_VALUE
} from "../../../utils/constants/bus-events-constants";
import { WEB_START } from '../../../utils/constants/pages';
import { REMOVE_PATH } from "../../../shared/components/map-viewer/constants/map-commands";

export default {
    name: 'ODHeader',
    components: {
        ADropdown,
        AHeroTitle
    },
    props: {
        ariaLabel: {
            type: String,
            default: 'To web start'
        }
    },
    data() {
        return {
            locale: this.$i18n.locale()
        }
    },
    computed: {
        ...mapState({
            languages: state => state.map.meta.languages
        }),
        ...mapGetters([
            'getActiveLocale'
        ]),
        dropdownOptions() {
            const result = [];
            this.languages.forEach(item => {
                result.push({
                    value: item,
                    label: this.$t(`ui.language-${item}`)
                })
            });
            return result;
        }
    },
    methods: {
        ...mapActions([
            'changeLocale'
        ]),
        handleChangeLocale(locale) {
            this.changeLocale(locale);
        },
        handleOpenClose(val) {
            this.$bus.$emit(SHOW_OVERLAY, val);
        },
        handleClick() {
            this.$bus.$emit(REMOVE_PATH);
            this.$bus.$emit(CHECK_SEARCH_VALUE);
            if (this.$route.name === WEB_START) return;
            this.$router.push({name: WEB_START})
        }
    }
}
</script>

<style lang="scss">
@import "o-d-header";   
</style>